import { BaseResponse } from '../../models/comm-http/responses/BaseResponse';
import { BillingRecurringTypes } from '../../models/ss-api/price.billing.cycle';
import { Component, OnInit } from '@angular/core';

import Swal, { SweetAlertIcon } from 'sweetalert2';
import { SelectItem } from 'primeng/api';
import { ssApiService } from 'app/services/ss-api.service';
import { DashboardLicenseResponse } from 'app/models/ss-api/responses/dashboard.license.response';
import { YardAddonPriceResponse } from 'app/models/ss-api/responses/yard.addon.price.response';
import { YardAddonOrderRequest } from '../../models/ss-api/requests/yard.addon.order.request';
import { CreditCardResponseArray } from 'app/models/ss-api/responses/credit.card.response';
import {DynamicDialogRef} from 'primeng/dynamicdialog';
import {DynamicDialogConfig} from 'primeng/dynamicdialog';

export interface IAddYardAddModel {
    title: string;
    subTitle: string;

    CreditCards: SelectItem[];
    SelectedCreditCard: number;

    License: DashboardLicenseResponse;
    YardPricing: YardAddonPriceResponse;

}

@Component({
    selector: 'yard-add-dialog',
    styleUrls: ['./yard-add-dialog.component.scss'],
    templateUrl: './yard-add-dialog.component.html'
})
export class YARDAddDialogComponent implements IAddYardAddModel, OnInit {

    IsBusy: boolean = false;

    confirmTitle: string = 'Add Product';
    confirmMessage: string = 'You are about to purchase a new product subscription. Your credit card will be billed.';

    successTitle: string = 'Product added';
    successMessage: string = 'Your purchase was successfull. You will recieve an email confirming your purchase.';

    errorTitle: string = 'Error';
    errorMessage: string = 'We were not able to process this request. Try again later or use a different credit card.';

    cancelledTitle: string = 'Cancelled';
    cancelledMessage: string = 'You cancelled this order.';


    AssignToOwner: boolean = true;
    Initials: string;
    title: string;
    subTitle: string;

    CreditCards: SelectItem[];
    SelectedCreditCard: number;

    License: DashboardLicenseResponse;
    YardPricing: YardAddonPriceResponse;

    SelectedBillingCycle: BillingRecurringTypes;


    PurchaseDisabled: boolean = false;
    ProductSelected: boolean = false;

    Initals: string = '';

    TodaysDate: Date = new Date();


    Credit: number = 0;

    result: any;


    constructor(
        public ref: DynamicDialogRef,
        public config: DynamicDialogConfig,
        private api: ssApiService
    ) {
    }

    ngOnInit(): void {
        this.title = this.config.data.title;
        this.subTitle = this.config.data.subTitle;
        this.CreditCards = this.config.data.CreditCards;
        this.SelectedCreditCard = this.config.data.SelectedCreditCard;
        this.License = this.config.data.License;
        this.YardPricing = this.config.data.YardPricing;
        this.SelectedCreditCard = this.CreditCards[0].value;
        this.GetCredit();
    }

    close() {
        this.ref.close();
    }

    CreditCardChanged(item: SelectItem) {

    }


    SelectedBillingCycleToString(): string {

        switch (this.SelectedBillingCycle) {

            case BillingRecurringTypes.Monthly:
                return 'month';

            case BillingRecurringTypes.Yearly:
                return 'year';

            default:
                return 'unimplemented';
        }

    }

    private PurchaseProduct(): Promise<any> {

        if (this.SelectedCreditCard == undefined)
            // we didn't change the credit card selection
            this.SelectedCreditCard = this.CreditCards[0].value;

        let request = new YardAddonOrderRequest();
        request.CCardID = this.SelectedCreditCard;
        request.LicenseID = this.License.LicenseID;
        request.YardProductID = this.YardPricing.YardProductID;


        return this.api.YardAdd(request)
            .toPromise()
            .then(response => {

                if (!response.Result)
                    return; // error

				this.result = response.Result;
				return response;
            });
    }


    ProcessOrder(): Promise<any> {
        // confirm
        return Swal.fire({
            title: this.confirmTitle,
            text: this.confirmMessage,
            icon: 'warning',
            showCancelButton: true,
            showCloseButton: true,
            confirmButtonText: 'Yes, order!',
            cancelButtonText: 'No, cancel',
            allowOutsideClick: false,
            showLoaderOnConfirm: true,
            preConfirm: () => {
                // try to order
                return this.PurchaseProduct();
            }
        });

    }

    async confirm() {
        await this.ProcessOrder().then(
            (response: any) => {

                // init dialog vars
                let cType = 'success';
                let cTitle = this.successTitle;
                let cMessage = this.successMessage;

                if (response.isDismissed) {
                    cType = 'error';
                    cTitle = this.cancelledTitle;
                    cMessage = this.cancelledMessage;
                } else if (!response.value || !response.value.Result) {
                    // not ok
                    cType = 'error';
                    cTitle = this.errorTitle;
                    cMessage = this.errorMessage;
                }

                // show result
                Swal.fire(
                    {
                        title: cTitle,
                        text: cMessage,
                        icon: cType as SweetAlertIcon,
                        showCancelButton: false,
                        showConfirmButton: false,
                        timer: 2500
                    })
                    .then(() => { }, () => { }); // keep this line to prevent promise error;

            },
            (dismiss) => {
                if (dismiss === 'cancel') {

                    if (!confirm)
                        return;

                    // show cancelled
                    Swal.fire({
                        title: this.cancelledTitle,
                        text: this.cancelledMessage,
                        icon: 'error',
                        showCancelButton: false,
                        showConfirmButton: false,
                        timer: 1000
                    })
                        .then(() => { }, () => { }); // keep this line to prevent promise error;
                }
            });

        this.result = true;
        this.close();
    }

    cancel() {
        this.result = false;
        this.close();
    }


    BillingTypeToString(type: BillingRecurringTypes) {
        return BillingRecurringTypes[type];
    }

    BillingTypeToPerString(type: BillingRecurringTypes) {
        if (type == BillingRecurringTypes.Monthly)
            return 'per Month';
        else
            return 'per Year';
    }

    productNameWebSafe(productName: string): string {

        let webSafeName = 'vip3d';

        if (productName == 'Pool Studio')
            webSafeName = 'poolstudio';
        else if (productName == 'VizTerra')
            webSafeName = 'vizterra';

        return webSafeName;

    }

    showAddCreditCard: boolean = false;


    cardAdded({cards, newCardId}: {cards: CreditCardResponseArray, newCardId: number}) {
        this.showAddCreditCard = false;
        this.updateCreditCardOptions(cards);
        this.SelectedCreditCard = newCardId;
    }

    addCardCanceled() {
        this.showAddCreditCard = false;
    }

    updateCreditCardOptions(newCards: CreditCardResponseArray) {
        this.CreditCards = [];
        newCards.forEach(card => {
            this.CreditCards.push(
                {
                    label: 'Name: ' + card.FirstName + ' ' + card.LastName +
                        ' - Last four: ' + card.LastFour +
                        ' - exp. Date: ' + card.ExpMonth + '/' + card.ExpYear,
                    value: card.ID
                });
        });
    }

    GetCredit() {
        this.IsBusy = true;

        let subscription = this.api.MemberCredit().subscribe(response => {
            subscription.unsubscribe();
            this.IsBusy = false;
            this.Credit = response.Data;
        }, error => {
            subscription.unsubscribe();
            this.IsBusy = false;
        });

    }

    GetPriceDue(): number {
        let totalPriceDue: number = 0;
        totalPriceDue += this.YardPricing.Pay;
        totalPriceDue -= this.Credit;
        if (totalPriceDue < 0 || Number.isNaN(totalPriceDue))
            totalPriceDue = 0;

        return totalPriceDue;

    }

    CreditUsed(): number {
        if (this.Credit > this.YardPricing.Pay)
            return this.YardPricing.Pay;
        else
            return this.Credit;
    }



}
